/**
 * List Schema of CompartilhamentoApp
 * @author Simpli CLI generator
 */
import {
  Helper,
  Schema,
  FieldSet,
  FieldComponent,
  Component,
} from 'simpli-web-sdk'
import {CompartilhamentoApp} from '@/model/resource/CompartilhamentoApp'

/* TODO: review generated schema */
export class ListCompartilhamentoAppSchema extends Schema {
  readonly name = 'ListCompartilhamentoApp'

  readonly fieldSet: FieldSet<CompartilhamentoApp> = {
    idCompartilhamentoAppPk: (): FieldComponent => ({
      is: Component.Render,
    }),
    motorista: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.motorista?.$id,
      },
    }),
    qtdCompartilhamento: (): FieldComponent => ({
      is: Component.Render,
    }),
  }
}
